import { render, staticRenderFns } from "./ElementSelector.vue?vue&type=template&id=bacfadf4&scoped=true&"
import script from "./ElementSelector.vue?vue&type=script&lang=js&"
export * from "./ElementSelector.vue?vue&type=script&lang=js&"
import style0 from "./ElementSelector.vue?vue&type=style&index=0&id=bacfadf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacfadf4",
  null
  
)

export default component.exports